export default __webpack_public_path__ + "static/hero-banner-cfd3e810a43ffc5185a4c6fda78ac8d7.png";